import { logError } from 'global/errors';
import services from 'api/services';

import {
  LOAD_REPORT_REQUEST,
  LOAD_REPORT_SUCCESS,
  LOAD_REPORT_FAILURE,
  UPDATE_TICKET_DEPARTMENT_REQUEST,
  UPDATE_TICKET_DEPARTMENT_SUCCESS,
  UPDATE_TICKET_DEPARTMENT_FAILURE,
  GENERATE_ANONYMISE_REPORT_LINK_REQUEST,
  GENERATE_ANONYMISE_REPORT_LINK_SUCCESS,
  GENERATE_ANONYMISE_REPORT_LINK_FAILURE,
  DISABLE_ANONYMISE_REPORT_LINK_REQUEST,
  DISABLE_ANONYMISE_REPORT_LINK_SUCCESS,
  DISABLE_ANONYMISE_REPORT_LINK_FAILURE,
} from './constants';

const { TicketService } = services;

export const loadReport = (id, isAnonymisedReport) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REPORT_REQUEST });
    const response = isAnonymisedReport
      ? await TicketService.loadAnonymiseReport(id)
      : await TicketService.loadReport(id);
    dispatch({ type: LOAD_REPORT_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_REPORT_FAILURE, error: ex.message });
  }
};

export const updateTicketDepartment = (ticketId, departmentId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_REQUEST });
    const ticket = await TicketService.updateTicketDepartment(ticketId, departmentId);
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_SUCCESS, data: ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const generateAnonymiseLink = (ticketId) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_ANONYMISE_REPORT_LINK_REQUEST });
    const response = await TicketService.generateAnonymiseLink(ticketId);
    dispatch({ type: GENERATE_ANONYMISE_REPORT_LINK_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GENERATE_ANONYMISE_REPORT_LINK_FAILURE, error: ex.message });
  }
};

export const disableAnonymiseLink = (anonymiseId) => async (dispatch) => {
  try {
    dispatch({ type: DISABLE_ANONYMISE_REPORT_LINK_REQUEST });
    const response = await TicketService.disableAnonymiseLink(anonymiseId);
    dispatch({ type: DISABLE_ANONYMISE_REPORT_LINK_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: DISABLE_ANONYMISE_REPORT_LINK_FAILURE, error: ex.message });
  }
};
